export default {
  statistics: {
    servicetype: "Service type",
    search: "search",
    exportfile: "export",
    submit: "submit",
    createdate: "created on",
    orderno: "order No.",
    businestype: "busines type",
    payment: "payment (including insurance and seervice fees)",
    insufee: "insurance fee",
    servicefee: "service fee",
    productname: "product name",
    total: "total",
    departmentname: "department name",
    selectdepart: "select dept.",
    costcenter: "cost center",
    expenseDepartment: "expense bearing department",
    selectcostcenter: "select cost center",
    selectExpenseDepartment: "select expense bearing department",
    projectcode: "project code",
    startdate: "started on",
    enddate: "ended on",
    paytotalmoney: "total consumption",
    avgticketprice: "avg ticket price",
    avgroomfee: "avg room fee",
    avgdiscount: "avg discount",
    breakbtrip: "violation policy",
    advdayinfo: "adv day info",
    day: "day",
    departpaysort: "dept. consumption ranking",
    costpaysort: "cost center ranking",
    expenseDepartmentRanking: "expense bearing department ranking",
    projectcodepaysort: "project code ranking",
    arrpaysort: "destination ranking",
    tonglist: "statistics list",
    tongview: "statistical view",
  },

  order: {
    ordertip: "You can view orders within one year online. If you need to check the order before, please call: 400-088-8020 (free toll call).",
    allorder: "all orders",
    startdate: "started on",
    endadte: "ended on",
    orderstatus: "order status",
    ordertype: "order type",
    searchkey: "enter product name or order No. to search",
    search: "search",
    number: "number",
    orderdetail: "order detail",
    ordertotalmoney: "total order amount",
    dealoperation: "deal operation",
    submit: "submit immediately",
    approval: "approve immediately",
    payment: "pay immediately",
    createorder: "re-order",
    oldsystem: "old system",
    rejectReason: "rejecting reason",
    reapproval: "reject in examination",
    approvalsucc: "pass the examination",
    selectvoy: "select the voyage you need to refund!",
    selectpass: "select the passenger you need to refund!",
    selectreason: "select reason for refunding",
    amendsucc: "succeed in submitting refunding application",
    flightchange: "flight change",
    selectchangepass: "select changing passenger",
    oldvoyageinfo: "ooriginal voyage info",
    selectedflight: "selected flight",
    policyok: "Conform rules",
    policyno: "Violate rules",
    build: "airrax",
    fuel: "fuel charge",
    changeflight: "change flight",
    flightlist: "flight list",
    changefee: "changing fee",
    changefeetip:
      "(The following fees are for reference only. The final amount is subject to the review of the airline company. If you have any questions, please call customer service:---)",
    changefeeabout: "estimated changing fee",
    upcabinfeeabout: "estimated upgrading fee",
    changeservicefee: "service fee for change",
    totalfee: "total",
    changereason: "reason for changing",
    changedetreason: "pls enter the detailed reason for changing (not required)",
    back: "back",
    submitapply: "submit application",
    selectchangepass: "select passenger!",
    flightsearchfail: "fail to search the conforming flight info!",
    flightchangereason: "pls select the reason for changing",
    losesource: " Please check flights",
    flightchangesucc: "succeed in applying for changing!",
    orderdetail: "Order Info",
    voyageinfo: "Voyage Info",
    flightpass: "passenger",
    contactpeople: "Name",
    costcenter: "cost center",
    expenseDepartment: "expense bearing department",
    policynoreason: "reason for violating policy",
    demandremark: "demand remark",
    fujianxinxi: "attachment info",
    btripinfo: "business trip info",
    procode: "project code",
    btripaim: "business trip purpose",
    btripMatter: "business trip matter",
    approvalstatus: "approval status",
    violate: "Violate",
    policydetail: "policy",
    vioreason: "reason for violating",
    reasondetail: "detailed reason",
    order: "order",
    bookingdate: "booking date",
    orderid: "order No.",
    oldorderid: "original order No.",
    bookingway: "booking way",
    paymentway: "payment way",
    totalmoney: "total",
    submitorder: "submit order",
    cancelorder: "cancel order",
    ordervoyage: "voyage",
    realtake: "actually take",
    share: "Share",
    orderchange: "change",
    orderamend: "refund",
    departcity: "depart from",
    arrivecity: "arrivie in",
    departdate: "depart on",
    arrivedate: "arrive on",
    hotelname: "hotel name",
    hotelphone: "hotel phone",
    hoteladdress: "hotel address",
    roomtype: "room type",
    cityname: "city name",
    arrivedate: "Check-in Date",
    departdate: "leave on",
    startstation: "start station",
    endstation: "end station",
    seattype: "seat type",
    tourpeople: "traveller",
    sequence: "sequence",
    name: "name",
    cardno: "card No.",
    birthday: "birthday",
    phoneno: "phone number",
    invoiceinfo: "invoice info",
    invoiceid: "invoice code",
    passname: "passenger name",
    invoiceno: "invoice no",
    seatno: "seat no",
    tradeinfo: "trade info",
    tradepeople: "trade person",
    tradeway: "trade way",
    tradetype: "trade type",
    trademoney: "trade amount",
    createtime: "created on",
    email: "email",
    phone: "phone",
    applyamend: "apply for refund",
    selectordervoyage: "select voyage",
    selectorderpass: "select passenger",
    selectorderreason: "select reason",
    cancel: "cancel",
    changeapply: "apply for changing",
    adultticket: "adult ticket",
    amendfee: "fee for refund",
    samechangefee: "fee for changing",
    changecondition: "condition for changing ",
    changeadopt: "allow to change",
    people: "people",
    completechange: "complete change",
    reimburseinfo: "Reimbursement info",
    travleorderinfo: "can provide complete schedule",
    bagkg: "baggage allowance",
    forfeebagkg: "free baggage allowance  20KG",
    loading: "loading",
    endststion: "arriving ststion",
    waitapprove: "to be approved",
    changeamendrule: "Refund/Change",
    trainamendrule:
      "There is no fee for refund 15 days (excluding) before departing. A fee for refunding at 5% of the ticket fare is charged for refund more than 48 hours before departing from the departing station; a fee for refund at 10% of the ticket fare is charged for refund 24 hours~48 hours before departing, and a fee for refund at 20% of the ticket fare is charged for refund less than 24 hours before departing.",
    touramendrule: "subject to the signed contract",
    selectPassengersChange: "select changing passenger",
    fillFlight: "fill in the fight info",
    depart: "depart",
    arrive: "arrive",
    date: "date",
    changereason: "pls enter the reason for changing",
    dueTo: "due on",
    for: "into",
    ChangeTo: "Changed to",
    WasteBack: "cancalled on",
    ExpectedRefundFee: "etsimated fee for refund",
    reasonRejection: "plas enter the reason for rejection",
    ordeCancel: "Cancel orde",
    isCancel: "confirm to cancel the order",
    confirm: "confirm",
    BusinessType: "BusinessType",
  },
  system: {
    clear: "Clear",
    combtripmemberlogin: "company business trip member login in",
    lchbtrip: "Licheng business btrip",
    simple: "simpler",
    free: "freer",
    lowermoney: "cheaper",
    prebtrip: "perfect business trip",
    unyouneed: "undestand your need",
    servicenotime: "comprehensive service with no time difference",
    costcenlower: "business trip cost lower by 30%",
    peoplecenter: "personal center",
    ri: "day",
    trtavleregtips: "If the amount is 0, it means no limit of amount, tick available for ticket, class and train seat ",
    firstcity: "first-class city",
    seccity: "second-class city",
    thrcity: "third-class city",

    none: "none",
    allmoney: "full price",
    discountdown: "below _ discount",
    deletefiletips: "confirm to delete the operation?",
    tips: "tips",
    cancel: "cancel",
    usericon: "usericon",
    uploadusericon: "upload usericon",
    changusericon: "change usericon",
    bangemail: "bind email",
    bangphone: "bind phone number",
    orderid: "order No.",
    ordervoyageinfo: "voyage info",
    bookingdate: "booking date",
    orderstatus: "order status",
    bookinguser: "booking user",
    btriprule: "Business trip rule",
    btripaim: "Business trip purpose",
    policyreason: "policy reason",
    bookinginfo: "booking Info",
    btripflow: "business trip approval",
    search: "search",
    add: "add",
    name: "name",
    number: "number",
    servicetype: "service type",
    chinese: "Chinese",
    english: "English",
    operation: "operation",
    copy: "Copy",
    update: "revise",
    delete: "Delete",
    delsucc: "succeed in deleting",
    inputcontent: "pls enter content",
    selectcustomers: "select customers",
    zhdescribe: "describe in Chinese",
    rule: "rule",
    ruleid: "rule No.",
    rulename: "rule name",
    travelregulations: "travel regulations",
    endescribe: "describe in Eng",
    btripflowname: "business trip approval name",
    btripflowrule: "business trip approval rule",
    selectbtriprule: "select business trip rule",
    selectbtripflow: "select business trip flow",
    needflow: "need approval",
    roleapplybtrip: "role applying rules",
    departrole: "dept. role",
    jobrole: "job role",
    employeeandcustomer: "employee customer",
    btripflowid: "business trip approval No.",
    btriprulename: "Business trip rule name",
    approvalfloename: "approval flow name",
    flowid: "flow No.",
    back: "back",
    save: "save",
    savesucc: "succeed in saving",
    operlogs: "operation logs",
    addsucc: "succeed in adding",
    updatesucc: "succeed in revising",

    businessname: "enterprise name",
    businessmanage: "business management",
    servicemanage: "service management",
    reportsmanage: "report management",
    pleaseselect: "pls select",
    pleasewrite: "pls fill in",
    companyinfo: "company info",
    companyname: "company name",
    city: "city",
    profession: "profession",
    contactname: "contact person's name",
    selectcycle: "select cycle",
    selectdate: "select date",
    selecttrade: "select trade",
    phonenoerror: "phone format error",
    emailerror: "email format error",
    contactnameerror: "contact person's name can't be blank",
    deliverymanage: "delivery management",
    addcontact: "new address",
    contactpeople: "consignee",
    address: "address",
    remark: "remark",
    postcode: "post code",
    contactphone: "contact phone",
    contactnickname: "simple address",
    contactemail: "contacting email",
    defaultaddress: "default address",
    setdefaultaddress: "SetDefault",
    addressinfo: "address info",
    peoplemanage: "personal management",
    lasterorder: "recent order",
    voyagesdate: "voyage canlendar",
    voyagesremark: "voyage remark",
    welcomelogin: "welcome to login",
    login: "Login",
    registernow: "Register",
    loginbyaccount: "Login by account",
    loginbyphone: "Login by dynamic code",
    loginbyother: "you can also login in other ways",
    wechat: "wechat",
    pleaseinputvalcode: "pleaseenter verification code",
    loginredittips: "skip to home page in X seconds...",
    accountinfo: "account info",
    peopleregister: "personal user",
    companyregister: "company register",
    kefucenter: "customer service center",
    loginout: "Logout",
    account: "account",
    pwd: "pwd",
    pwdtips: "pls enter pwd",
    forgetpassword: "forget pwd?",
    saveloginstats: "save login status",
    accounttips: "pls enter phone number or email",
    password: "Login pwd",
    passwordtips: "pls enter 8-16 digits",
    passwordfirstlevel: "weak",
    passwordfirstleveltips: "include Eng letters and numbers",
    passwordsecleveltips: "include Eng letters, numbers and special symbols",
    passwordseclevel: "medium",
    passwordlastleveltips: "include capital and lowercase Eng letters, numbers and special symbols",
    passwordlastlevel: "strong",
    confirmpassword: "confirm pwd",
    validecode: "verification code",
    validecodeignorecase: "case-insensitive",
    changevalidecode: "change another one",
    dynavalidecode: "dynamic verification code",
    dynavalidecodetips: "pls enter dynamic verification code",
    loginedregistertips: "You have already logged in to Licheng business travel account, if you want to register your personal account, please quit first!",
    agreeprotocol: 'Agree to "Service Agreement"',
    reset: "reset",
    registeproblem: "register problem?",
    inputpwdagain: "enter pwd again",
    notsamepwd: "not the same pwd",
    emailaccounttips: "send verification code to email ",
    phoneaccounttips: "send verification code to phone",
    sendvalidecode: "send verification code ",
    registersucc: "succeed in registering",
    registersucctips: "succeed in registering, pls log in",
    companyaccounttips: "This account is already a company account. To register a company account, please quit and re-register.",
    codesendtips: "already sent",
    codeagain: "acquire verification code",
    resetaccountback: "back to the last step",
    resetaccountfirst: "fill in the account",
    resetaccountsec: "ID verification",
    resetaccountthr: "set new pwd",
    resetaccountlast: "complete",
    submit: "submit",
    resetphoneaccounttips: "you can reset pwd by valid bond email",
    resetaccountbyphone: "reset by phone verification",
    resetemailaccounttips: "you can reset pwd by valid bond email",
    resetaccountbyemail: "reset by email verification",
    resetpwdbyvalide: "reset pwd",
    sendresetpwdcodetips: "Licheng Network has sent a verification code to your bond (phone or mailbox), pls check and enter the code",
    resetpwdcodename: "The verification code you received",
    confirm: "confirm",
    invoiceinfo: "",
    yes: "yes",
    no: "no",
    invoicemanage: "invoice management",
    invoicerole: "invoice role",
    invoicetype: "invoice type",
    invoicename: "invoice name",
    identifynumber: "taxpayer identification number",
    invoicebankname: "bank name",
    invoicebankaccount: "bank account",
    invoicecompanyadsress: "registered adsress",
    invoicecompanyphone: "registered phone",
    invoicelistlefttitle: "saved",
    invoicelistrighttitle: "address",
    updatedate: "update data",
    invoicetypetips: "pls select invoice type",
    invoicenametips: "pls enter invoice title",
    identifynumbertips: "pls enter taxpayer identification number",
    invoicebanknametips: "pls enter bank name",
    invoicebankaccounttips: "pls enter bank account",
    invoicecompanyadsresstips: "pls enter registered adsress",
    invoicecompanyphonetips: "pls enter registered phone",
    messagetemplatelist: "message template list",
    messagename: "message name",
    messagetype: "message type",
    messagetemplatename: "message template name",
    messagetemplatetype: "message template type",
    messagetemplatecontent: "message template content",
    updateuser: "updated by",
    disables: "disable",
    enable: "enable",
    managesetting: "management setting",
    messagetemplatestatus: "status",
    addmessagetemplate: "update message template",
    username: "username",
    cardno: "card No.",
    cardvaliditydate: "validity date",
    cardincountry: "card issued by",
    cardimg: "card img",
    reproveimg: "positive img",
    deleteimg: "delete img",
    reverseimg: "reverse img",
    uploadimg: "upload img",
    companyinfo: "basic info",
    cardinfo: "card info",
    contactinfo: "contact info",
    customermanage: "customer manager",
    companyname: "company name",
    companynickname: "company's short name",
    englishcompanyname: "english name",
    companyemail: "company email",
    companyaddress: "company address",
    companytype: "company type",
    capitaltype: "capital type",
    companysize: "company size",
    companyprofession: "company profession",
    companyremark: "remark",
    rolecontactpeople: "contact person",
    rolecontactpeoplename: "contact person's name",
    importcontact: "import address",
    phoneareacode: "phone area code",
    contactaddress: "contact address",
    province: "province",
    city: "city",
    district: "district",
    changecompanypeopletips: "Tip: You will no longer have admin rights after the receiver receives the company authority",
    companypeople: "receiver",
    regularcard: "regular card",
    regularcardno: "card No.",
    disclaimer: "disclaimer",
    fullname: "full name",
    nickname: "short name",
    sex: "sex",
    country: "nationality",
    name: "name",
    charge: "supervisor",
    selectcharge: "select supervisor",
    companyorgan: "institutional framework ",
    actionupdatetips: "If you do not need to set authority, you can click Save to go to the next step.",
    roleaction: "role authority",
    allemployee: "all employees",
    roleemployee: "role employee",
    roleemployeetips: "the employee has been in the current dept.",
    setmanage: "set management",
    workcity: "work city",
    workjob: "job",
    workname: "work name",
    worktime: "work time",
    workdatarang: "checking range",
    birthday: "birthday",
    list: "list",
    createtime: "created on",
    startdate: "start on",
    enddate: "end on",
    sequence: "sequence",
    supername: "superior name",
    updatetime: "update on",
    detail: "detail",
    setting: "setting",
    serviceinfo: "service info",
    servicename: "service name",
    publishname: "publishing name",
    applyarea: "applicable area",
    servicepublic: "public or not",
    publishservice: "publish service",
    publishedservice: "service has been published",
    advancetime: "advance time",
    workperiod: "cycle",
    publishsave: "confirm to publish",
    servicefarelist: "service fare list",
    servicefarename: "service fare name",
    servicefareid: "service fare No.",
    companyid: "company No.",
    servicefarestatus: "service fare status",
    policystatus: "policy status",
    customername: "customer name",
    bookingway: "booking way",
    workingtime: "working time",
    servicefarebyworkingtime: "Is it calculated according to working hours?",
    money: "yuan",
    other: "other",
    fare: "fare",
    roles: "role",
    jobs: "job",
    departments: "dept.",
    companys: "company",
    customers: "level ",
    role: "role",
    job: "job",
    employee: "employee",
    user: "user",
    guest: "frequent customer",
    customer: "customer",
    costcenters: "cost center",
    expenseDepartments: "expense bearing department",
    flowid: "flow No.",
    flowname: "flow name",
    flowmanage: "flow management",
    dealpeople: "handled by",
    up: "Up",
    down: "Down",
    langsetting: "Language",
    japan: "Japanese",
    english: "English",
    china: "Chinese",
    opened: "Opened",
    closed: "not opened",
    expired: "expired",
    disable: "disable",

    systemsafe: "safety setting",

    downloadtemplate: "download template",

    PermissionEmployees: "Permission employee",
    GrantDate: "Grant on",
    ExpirationDate: "Expire on",
    saveInfo: "Save info",
    approvalList: "Approval list",
    StaffName: "Staff Name",
    detail: "Detail",
    CompanyPage: "Company Page",
    selectCityAgain: "Select city again",
    ChooseShipCompany: "Select airline",
    FutureGenerations: "SelectAll",
    TheSelected: "Invert Selection ",
    QuickFindSelection: "Quickly find and select",
    shipCompany: "Applicable airline",
    shipSpace: "Select shipping space",
    applySpace: "Appliable shipping space",
    AsOfTheDate: "Deadline",
    AddLevel: "Add Level",
    LevelNames: "Level Name",
    LevelCode: "Level Code",
    RetentionSet: "Retention setting and customer configuration",
    LeaveSome: "Leave some",
    keepMoney: "Leave money",
    ServiceLevelAdd: "add service level",
    ProductCategory: "Product category",
    SubscribeCustomer: "SubscribeCustomer",
    SaveButtonSet: "Retention setting ",
    localChineseName: "enter the Chinese name of the area",
    localEnglishName: "enter the Eng name of the area",
    PreviewPicture: "Preview Picture",
    keywordsFilter: "enter key words to filter",
    DataIntegrity: "Data integrity",
    PerfectInformation: "complete information",
    AuthorizationState: "Authorization state",
    accountNumber: "pls enter account number",
    DynamicCode: "Dynamic Code",
    congratulations: "congratulations",
    ClickNoResponse: "Skipping to Licheng Business Travel Platform, if there is no response within 6 seconds, please click",
    Here: "Here",
    PasswordChangedSucc: "succeed in changing pwd",
    selectParentDirectory: "select parent directory",
  },
  mall: {
    one: "one",
    two: "two",
    three: "three",
    four: "four",
    five: "five",
    six: "six",
    seven: "seven",
    eight: "eight",
    nine: "nine",
    ten: "ten",
    contactUs: "Contact Us",
    adequateTxt: "Sufficient",
    sheet: "pcs",
    Remaining: "Only left",
    Amended: "Amended",
    Changeed: "Changeed",
    Amending: "Amending",
    Changeing: "Changeing",
    Booking: "Booking",

    Changeed: "Changeed",
    Booked: "Booked",
    AllAmending: "Pend AllAmending",
    AllChangeing: "Pend AllChangeing",
    AllBooking: "Pend AllBooking",
    AllAmended: "AllAmended",
    AllChangeed: "AllChangeed",
    AllBooked: "AllBooked",

    hotelinfo: "Hotel Info",
    ReElectionFlight: "Re-election flight",
    TaxExclusive: "tax-exclusive",
    notificationMessageFlight:
      "Notice: if you need, you can click here to enter the international demand list.To meet any of your travel needs You may also call:",
    Hotline: "Hotline consultation.",
    EnfantYears: "2-14 year",
    InfantYears: "under two",
    budget: "budget",
    Mylicheng: "My licheng",
    SupportChinese: "Support Chinese/pinyin/Jane spell input",
    SupportCode: "Support Chinese/pinyin/jianpin/city code input",
    hotCity: "hot",
    attendance: "Attendance",
    hostPlace: "Host place",
    activityBudget: "Activity budget",
    PartyNumber: "Party Nums",
    internationalHotel: "Inter hotel demand",
    pay: "pay",
    NextPage: "NextPage",
    PreviousPage: "PreviousPage",
    selected: "selected",
    data: "data",
    strip: "strip",
    paginal: "paginal",
    page: "page",
    AuxiliaryWord: "The",
    searchName: "Enter name search (click the right button to add it as temporary passenger train)",
    keywordsPlaceholder: "Enter keywords to search",
    selectName: "select Name",
    Station: "Station",
    TotalAmount: "Total Amount",
    checkIn: "check-in",
    Broadband: "Broadband",
    AttentionPlease: "(Special reminder: please fill in the reasons for violation, so as to better pass the audit)",
    TripAgainst: "The trip is against",
    ContraryReason: "Reason",
    DetailReason: "DetailReason",
    Sex: "Gender on ID",
    Nationality: "Nationality",
    Birthdate: "Date of birth",
    Mobile: "Mobile",
    ID: "ID",
    PassengerName: "Name",
    Policy: "Policy",
    price: "Price",
    BedType: "Bed Type",
    Window: "WINDOW",
    feature: "Feature",
    ViewsMore: "Views more",
    durationTime: "Duration",
    flightInfo: "Flight information",
    next: "Next",
    selectedconsumer: "selected customer",
    btripflow: "business trip approval",
    bookingcenter: "Booking",
    demandorder: "demand order",
    selectcompany: "select company",
    costcenter: "CostCenter",
    expenseDepartment: "Expense Bearing Department",
    approvalpolicy: "approval policy",
    bookinguser: "booking staff",
    pleaseselect: "please select",
    bookingsearch: "booking search",
    btripaim: "Purpose",
    budgetCode: "BudgetCode",
    budgetIntro: "BudgetIntro",
    projectcode: "ProjectCode",
    bookingtype: "booking type",
    applyarea: "appliable area",
    serviceset: "service fee setting",
    flowinfo: "approval flow ",
    name: "name",
    flowname: "approver's name",
    btriprule: "Business trip rule",
    priority: "priority",
    pricelimit: "price limit",
    bookinginfo: "Booking Info",
    zhtips: "Chinese tips",
    entips: "eng tips",
    updateorder: "update order",
    submitorder: "submit order",
    tourpasstips: "Travel order does not support this passenger type",
    createsucc: "succeed in creating order",
    orderapprovalsucc: "succeed in approving order",
    pnr: "import code",
    flightno: "flight No.",
    flightdate: "flight date",
    airportinfo: "airport info",
    cabin: "cabin",
    realflight: "actual carrier",
    depairportcode: "dep airport code",
    arrairportcode: "arr airport code",
    hotelname: "hotel name",
    hotelphone: "hotel phone",
    hoteladdress: "hotel address",
    hotelarrivedate: "Check-in Date",
    hoteldepartdate: "leave on",
    hotelamenddate: "Check-out Date",
    roomnum: "room num",
    roomtype: "room type",
    roombedtype: "room bed type",
    breakfast: "Breakfast",
    consumerDate: "Check-in",
    finishedDate: "Check-out",
    changeamendrule: "Refund/Change",
    aimcity: "destination city",
    selectdate: "Select date",
    keywords: "Keywords",
    hotelkeywords: "(option) hotel name / landmark / business district",
    search: "Search",
    qi: "start ",
    searchdetail: "View Details",
    notReserve: "No available room types",
    traffmap: "traffic map",
    sheetzone: "street zone",
    btripno: "Violate",
    btripyes: "Conform",
    room: "room",
    spec: "Square meter",
    live: "Tenantable",
    floor: "Floor",
    layer: "Layer",
    productname: "Product name",
    averagerate: "Average daily",
    breakfastInfos: "Breakfast information",
    breakfastyes: "Including",
    breakfastno: "Excluding",
    cancelno: "Non-Refundable",
    timecancel: "Refundable",
    plenty: "Enough",
    select: "Select",
    hotelfacilities: "hotel facilities",
    wifi: "wifi",
    none: "none",
    parking: "parking lot",
    allfacilities: "all facilities",
    activefacilities: "activity facilities",
    serviceproject: "service project",
    hotelpolicy: "hotel policy",
    depandarr: "check in and out",
    chdpolicy: "chd policy",
    mealment: "mealment",
    apartment: "apartment",
    theinn: "inn",
    familyhotel: "family hotel",
    youthhostel: "youth hostel",
    coupleshotel: "love hotel",
    gardencourtyard: "garden courtyard",
    seaview: "seaview",
    generated: "agritainment",
    hotspringshotel: "hot spring hotel",
    golfhotel: "golf hotel",
    siheyuan: "quadrangle courtyard",
    villa: "villa",
    cookingdinnerparty: "cooking party",
    businesstriphome: "business trip home",
    recreationalfeeling: "recreational feeling",
    hospital: "hospital",
    holidayleisure: "holiday leisure",
    traininglearn: "training and learning",
    party: "party",
    honeymoontrip: "honeymoon trip",
    boutiquehotel: "boutique hotel",
    indoorswimmingpool: "indoor swimming pool",
    outdoorswimmingpool: "outdoor swimming pool",
    gym: "gym",
    businesscenter: "business center",
    meetingroom: "meeting room",
    hotelrestaurant: "hotel restaurant",
    wakeupcall: "wakeup call",
    luggage: "luggage deposit",
    doublebed: "double bed",
    bigbed: "big bed",
    pickupservice: "pickup service",
    pet: "pet",
    creditcard: "credit card",
    username: "user name",
    usersex: "sex",
    PassengerType: "Type",
    cardtype: "card type",
    cardno: "card No.",
    contactphone: "contact phone",
    birthday: "Date of birth",
    usercountry: "nationality",
    cardvaliditydate: "card validity date",
    add: "add",
    delete: "Delete",
    passselect: "select passenger",
    contactpeople: "contact people's name",
    contactphone: "contact phone",
    contactemail: "contact email",
    salesprice: "Sales price",
    marketprice: "Market price",
    supplyprice: "Settlement price",
    tourdepcity: "Departure City",
    tourarrcity: "Arrival City",
    teamno: "Group No.",
    tourdepdate: "Travel date",
    remark: "Remark",
    traininfo: "Train info",
    trainno: "Train No.",
    trainseattype: "Train seat type",
    traindepdatetime: "Depart Time",
    trainarrdatetime: "Arrival Time",
    traindepdate: "Departure Date",
    amendtime: "time limit for changing and refunding",
    moneysourceairway: "The actual amount is subject to the review of the airline",
    amendruletips: "The above adult refunding and changing rules and fee standards are for reference only, subject to the airline",

    adultticket: "adult ticket",
    amendfee: "fee for refunding",
    samechangefee: "fee for chaning",
    changecondition: "condition for changing",
    changeadopt: "allow to change",
    people: "people",
    completechange: "complete changing",
    reimburseinfo: "Reimbursement info",
    travleorderinfo: "can provide complete schedule",
    travleinvoince: "Provide difference invoices and itineraries",
    bagkg: "baggage allowance",
    forfeebagkg: "free baggage allowance  20KG",
    realtake: "acually take",
    realtaketips: "Please check in according to the actual flight.",
    share: "Share",
    airplanemodel: "Airplane",
    isstop: "Stops",
    allprice: "full price",
    discount: "Dis",
    protocolprice: "Negotiate",
    build: "airrax",
    fuel: "fuel charge",
    booking: "Book",
    flightok: "confirm",
    allprices: "More",
    flightnum: "pcs",
    flightnumtips: "__ left nly",
    flightgo: "flight go",
    flightback: "flight back",
    flightdetail: "Flight detail",
    totalmoney: "total amount",
    flightticket: "domestic flight ticket",
    iflightticket: "international flight ticket",
    screening: "Filter",
    clear: "Clear",
    flightvuelo: "non-stop/transit",
    flightdeptimes: "Departure time",
    airways: "Airline",
    depairport: "Departure airport",
    arriveairport: "Arrival Airport",
    checkflightgo: "selected flight go",
    changeflight: "change flight",
    flightlisttips: "flight info",
    flightdeptime: "Departure time",
    flightarrtime: "arr time",
    flightprice: "Flight price",
    nostop: "Nostop",
    transfer: "{time} in {city}",
    NostopOrTransfer: "Nostop/Transit",
    ShareFlight: "sharing flight",
    HideShareFlight: "Hide shared flight",
    TransferVoyage: "Transit",
    am: "Morning",
    noon: "Noon",
    pm: "Afternoon",
    firstcabin: "First calss",
    businesscabin: "Business class",
    economycabin: "Economy Class",
    createflightorder: "confirm the next step",
    loading: "loading",
    flightpricechange: "The flight price has changed, please confirm the order!",
    tips: "tips",
    confirm: "cofir",
    flightbookingtitel: "my Licheng ",
    flightbooking: "flight booking",
    orderdetail: "order info",
    contactinfo: "Contact details",
    taketicketway: "Delivery",
    departcity: "Departure City",
    arrivecity: "Arrival City",
    destination: "Destination",
    departdate: "Departure time",
    arrivedate: "arr time",
    backdate: "Return Date",
    loginuser: "Current user",
    priceway: "Price terms",
    pricestips: "The ticket provided on this page is in net price and does not include service charge.",
    firtransfer: "1 transition",
    sectransfer: "2 transition and above",
    transfercitys: "Transit city",
    economy: "economic class",
    business: "business class",
    first: "first calss",
    premiumecon: "super economic class",
    premiumebus: "super business class",
    premiumefirst: "super first class",
    iflightcitytips: "Please slect an international city!",
    approvalSelectCitytips: "To arrive at the destination city, there must be an approved itinerary for the flight!",
    approvalDepartDatetips: "The departure date must fall within the date range specified in the approval form!",
    approvalArriveDatetips: "The return date must fall within the approved date range!",
    approvalSelectHotelCitytips: "The destination city must have the approval form for the entire journey!",
    iflightbookingtips: "There are only __ ticket left for the flight you select",
    policyyes: "Conform",
    policyno: "Violating policy",
    priceandtax: "Tax included",
    stoptime: "Stop time",
    hotel: "Hotel",
    hotelpeoplenum: "number of people living ",
    hoteldeskphone: "reception phone",
    hotelleveltitle: "Stars from high to low",
    hotelpricetitle: "Price from high to low",
    below: "above",
    above: "below",
    hotelstart: "2-Star & Below / Budget",
    threehotelstart: "3-Star / Comfort",
    fourhotelstart: "4-Star / Upscale",
    fivehotelstart: "5-Star / Luxury",
    position: "location",
    nolimit: "Unlimited",
    adminregion: "District",
    businesszone: "Business district",
    startlevel: "Star Rating",
    contractHotel: "Contract Hotel",
    huazhuHotel: "Huazhu Hotel",
    facilities: "Facility",
    service: "service",
    hotelcounttips: "hotels",
    hotelcountall: "Total",
    hotelinfoorstart: "Hotel Infon / Star Rating",
    referprice: "Reference Price",
    reselect: "Reselect",
    chinahotel: "Domestic hotel",
    interhotel: "international Hotel",
    bookinghotel: "hotel reservation",
    hotelbookinginfo: "Booking Info",
    depandarrdate: "check-in-out",
    night: "nights",
    insure: "Insurance",
    hotelroomtype: "Room type",
    hotelproductcount: "More Products",
    chinatrain: "Domestic train",
    trainbooking: "Train ticket reservation",
    trainusernametip: "Name cannot be blank",
    trainusercardtip: "Please complete the certificate information",
    trainrecard: "ID card cannot be repeated",
    trainseatin: "succeed in booking, occupying seat",
    selectseatfree: "Free Selection",
    selectedseat: "Select",
    trainwindow: "Window",
    aisie: "Aisle",
    trainseattips: "Priority is given to designated seat. If there is no ticket for the selected seat, it will turn to other seats.",
    noselectseat: "Unselect",
    change: "Change",
    timelength: "Duration",
    trainticketnum: "Number",
    trainchangamendinfo: "Refund/Change explain",
    traindepandarrstation: "dep/arr station",
    traindepandarrtime: "dep/arr time",
    trainlogin12306tip: "Log in to 12306 account to directly link to the railway official system, issuing tickets faster!",
    login: "Log in",
    account: "account number",
    login12306user: "12306 username",
    login12306pwd: "Please enter your password",
    loginerror: "wrong user name or password",
    loginout: "quit",
    logintip: "logged",
    btripinfo: "Business Info",
    shenpipingzheng: "Certificate Of Approval",
    youshenpipingzheng: "Within Certificate Of Approval",
    wushenpipingzheng: "Without Certificate Of Approval",
    shenpizhuangtai: "Status Of Approval",
    chuchaishenqingiworkyishenpi: "Travel application iworker Approved",
    shangweishenpi: "Not Approved",
    shenpidanhao: "Approval Number",
    yijishenpi: "Primary Approval",
    shangchuanfujian: "Upload Attachment",
    fujianliebiao: "Attachment List",
    inputcontent: "Please enter content",
    btripordertip: "The following trip violates the business trip policy and needs to supplement the reason for violation",
    btriporderttip: "(Special reminder: Please fill in the reasons for violation to better pass the review)",
    ordervoyage: "trip",
    violate: "Violate",
    policydetail: "Policy",
    policynoreason: "reason for violating the policy ",
    policyreasondetail: "Detailed reason for violation ",
    consumerinfo: "Passenger Info",
    consumernametip: "Name should be consistent with the boarding pass",
    phoneareano: "area code ofMainland China",
    phonenotips: "The passenger's mobile phone number is used to receive flight dynamic information.",
    saveconsumer: "Save as a frequent passenger",
    selectconsumer: "select passenger",
    addconsumer: "Add passenger",
    consumertip:
      "Important reminder: In order to ensure the trip, pls fill in the ID number accurately and the ending date of the trip must be at least 6 months earlier than the expiration date of the document.",
    writeinfomation: "Filling explanation",
    demandremark: "Demand note",
    welcomelogin: "Welcome to login",
    registernow: "Sign up now",
    register: "Registered",
    loginbyaccount: "Login by account",
    loginbyphone: "Login by dynamic code",
    loginbyother: "You can also log in in the following ways",
    wechat: "WeChat",
    addressinfo: "Address",
    Add: "Add",
    defaultcontact: "Default",
    settingdefaultcontact: "set as the default address",
    edit: "Edit",
    contactpeople: "Name",
    contactphone: "Mobile",
    contactemail: "Email",
    adddemand: "Demand",
    voyagetype: "Voyage type",
    consumertype: "Passenger Type",
    adult: "adult",
    child: "child",
    infant: "baby",
    firstflightsearchtips: "Ifthe total number of passengers (excluding babies) is more than 9 people, please fill out",
    flightdemandorder: "Ticket demand list",
    lastflightsearchtips: "Make a reservation.",
    firstiflightsearchtips: "A maximum of 2 children and 1 baby can be taken by per adult. If there are special demands, pls",
    adminregionhotel: "Hong Kong, Macao and Taiwan",
    unsubmit: "Unsubmitted",
    submited: "submitted",
    chenking: "under review",
    paymoney: "Paid",
    etdzticket: "Ticket issued",
    directclose: "deal done",
    searchtrainbytraintype: "Search only for high-speed trains",
    selectfrequent: "select frequent passengers",
    frequent: "frequent passengers",
    addtemporaryconsumer: "Add temporary passenger",
    home: "Home",
    tour: "Tour",
    train: "Train",
    flight: "Flight",
    car: "Car rental",
    food: "Food",
    btripplateform: "Platform",
    comcoop: "Cooperation",
    appdownload: "AppDownload",
    meeting: "Exhibition",
    visa: "visa",
    tourism: "ConferenceTravel",
    stationname: "Station name",
    trainstoptime: "Staying time",
    stopstationname: "transit stop",
    soldout: "Book",
    start: "Depart",
    over: "Passing",
    end: "Arrival",
    yu: "remain",
    trainbatch: "Train type",
    startorvoer: "Depart/ Stop",
    startstation: "Depart Station",
    endstation: "Arrival Station",
    changeticket: "Ticket change",
    pleasepasstochange: "Please select the passengers who need to change",
    pleaseselectnewdate: "Please select the changed date",
    oldtraininfo: "Original train information",
    gctrain: "G/C high-speed rail",
    dtrain: "D EMU",
    ptrain: "ordinary",
    traindeptime: "Departure time",
    trainarrtime: "Arrival time",
    trainstart: "Depart",
    trainover: "Stop",
    hour: "hour",
    minute: "minute",
    trainchangeinfo: "Changed train information",
    changetrain: "Changed to",
    changefee: "fee for changing",
    changeservicefee: "service fee for changing",
    totalfee: "total",
    changereason: "Reason for change",
    checking: "to be reviewed",
    boyin: "Boeing",
    kongke: "Airbus",
    zhuanxiangjia: "Exclusive",
    analysis: "Passenger analysis",
    contact: "Contact person",
    bigcus: "Big customer",
    airway: "Airline",
    selectcom: "Please select a company first",
    nameisetm: "Passenger name cannot be blank",
    writenametype: "Please enter the correct name (Chen/Wenjun)",
    baoxianset: "Insurance configuration",
    saleandcus: "Sales / Customer Service Representative",
    recommendair: "Recommended flight",
    more: "More",
    hide: "hide",
    triprulename: "business trip policy",
    hightsearch: "Advanced Search",
    cabinlevel: "Class of cabin",
    submitapply: "submit application",
    interdemand: "demand orders of international and Hong Kong, Macao and Taiwan flight ",
    alltotal: "Total",
    demandcus: "If you have any questions, you can contact customer service. We will solve the problem in time for you.",
    voyageinfos: "flight information",
    addvoyage: "Add flight",
    passinfos: "Passenger information",
    passnum: "Number of passengers",
    sui: "year old",
    twosui: "Under two years old",
    firstairway: "Preferred airline",
    phoneno: "Mobile",
    email: "Email",
    submit: "Submit",
    demandprobtip: "If you have a problem with the submission, please consult:",
    normal: "ordinary",
    student: "student",
    newimmigrant: "New immigrants",
    worker: "laborservice",
    submitordersucc: "succeed in submittingorder ",
    hotelfare: "Room rate",
    contservicefee: "inclduingservice fee",
    hotelinfoimp: "Hotel import",
    addhotel: "Add hotel",
    inputprice: "Please enter the correct amount",
    inputpriceerror: "The maximum amount cannot be less than or equal to the minimum amount",
    starrankdesc: "Stars sorted by recommendation",
    starrank: "Stars sorted from high to low",
    starrankasc: "Stars sorted from low to high",
    pricesort: "prices from high to low",
    pricesortdesc: "PriceS from low to high",
    clickrecomend: "Click to recommend",
    caclhotelprice: "Accounting for price...",
    none: "no",
    freebroadbang: "Free broadband",
    broadband: "Charged broadband",
    freewifi: "Free WIFI",
    wifi: "Charged WIFI",
    imgshow: "Image display",
    additinfos: "Extra Info",
    insurinfos: "Insurance Info",
    surname: "last name",
    givenname: "first name",
    orderpassup: "The upper limit for passengers on a single order",
    orderpassupend: "For more people, please contact customer service!",
    cabintype: "Class type",
    selectcabin: "select class",
    safetrip: "safet travel",
    downloadapp: "download Licheng app",
    selectchangepass: "Please select a passenger!",
    searchpassup: "9 passengers at most!",
    selectcontact: "Select contact person",
    cancel: "cancel",
    tourindextip: "Meet your business trip needs and provide a full range of service solutions for business travellers.",
    tourdetailcall: "For details, pls consult",
    yearmeet: "Annual meeting",
    yearmeettips: "Full-process tracking service to create the highest-end corporate annual meeting",
    comyearmeet: "Company Annual Meeting",
    comtourtips: "Customize the most comfortable travel itinerary for company needs",
    comtour: "Company Travel",
    teambuild: "team building",
    teambuildtips: "Provide customized outdoor team building services for enterprises",
    createteambuild: "team building planning",
    exhibit: "Exhibition",
    exhibittips: "Provide one-stop conference planning and execution services for customers",
    comexhibit: "Conference exhibition",
    trainordercretips:
      "The upper limit for passengers on a single order is 5. If there are more people traveling, please contact customer service or make another order.",
    trainpassrepeat: "The passenger name cannot be repeated.",
    trianorderpassup: "You can only select up to 5 passengers.",
    inputpassgivenname: "Please enter the passenger first name.",
    inputpasssurname: "Please enter the passenger's last name.",
    trainpassseattips: "The number of passengers exceeds the number of seats selected",
    aisle: "aisle",
    NeedInvoice: "need invoice",
    NoInvoice: "Do not need invoice",
    delway: "Delivery Method:",
    exprefee: "Courier fees:",
    addresspass: "Recipient",
    postcode: "Postal code",
    deladdress: "delivery address",
    inputphoneno: "Please enter the phone number",
    inputphonerealno: "Please enter the correct phone number",
    inputtickettitle: "Please enter the invoice title",
    inputaddresspass: "Please enter the recipient",
    inputdeladdress: "Please enter the recipient address",
    Invite: "Pick up",
    Mail: "mail",
    nothing: "No need",
    parper: "Paper invoice",
    tourservicefee: "Travel service fee",
    express: "express delivery",
    ticketfare: "Ticket face",
    trainnamecardtips: "thename should be consistent with the name of the travel document",
    phonecountry: " Area Code ofMainland China: 86",
    phoneinfotips: "The passenger's mobile phone number is for receiving short message on the mobile phone",
    savecuspass: "Save as a frequent passenger",
    triprulemanage: "Travel management",
    trainorderseat: "Please select a seat for the selected passenger",
    createordernow: "Booking",
    parenter: "Partner",
    aboutus: "about us",
    companyinfo:
      "Licheng Business Trip is China's leading travel management company. It is affiliated to Licheng Group. Over the past ten years, it has relied on strong resources, advanced technology, excellent service and professional management, and provided services for more than 6,000 medium and large enterprises, including more than 120 Fortune Global 500 companies and more than 100 Chinese Fortune 500 companies.",
    companywechat: "Follow the Official Account of Licheng Business Trip",
    companyname: "Licheng Business Trip",
    simple: "simpler",
    free: "Freer",
    lowermoney: "chepaer",
    traintuiinfo: "instructions for refunding",
    traintuiinfo1:
      "1: Once the purchase agent is successful and the ticket is not picked up, you can enter “My Order” and click the train order to apply for refundinh according to the prompt more than 35 minutes before the departure; the railway administration charges fee for refunding within 15 days before the departure  according to the echelon.",
    traintuiinfo2:
      "2: Once the purchase agent is successful and the ticker has been picked up, or it is less than 35 min before the departure, you need to bring the original valid certificate of the passenger and the train ticket to the ticket refund window of the train station before the departure.",
    trainchanginfo: "instructions for changing",
    trainchanginfo1:
      "1: If the paper ticket is not picked up and it is more than 35min before the departure, you can change to trains with price equal to or lower than the original ticket fare. In other conditions that it cannot be changed online, it is required to go to the train station window before departure.",
    trainchanginfo2:
      "2: more than 48 hours before the departure, you can change to trains within the pre-sale period. Within 48 hours before departure, you can change to the trains before 24:00 on the date of the ticket, and change to trains after the date of the ticket will not be processed.",
    trainchanginfo3:
      "3: If the fare of the new ticket that is lower than the original ticket, the difference is partially refunded and the current refund fee is imposed.",
    datetimenotrain: "ticket for thecurrent date is not sold now",
    NoTrainSearch: "No train inquiry service is available during the current time",
    ReserveHint:
      "It is a non-connecting flight. If one of the flights is changed, the passenger who needs to cancel the other flight will bear the corresponding cancellation fee.",
    chailvguize: "Travel Policy Name",
    guonei: "Domestic",
    guojie: "International",
    jipiao: "Flight",
    jiudianguize: "Hotel Policy",
    huoche: "Train",
    guize: "Rules",
    zuidijiajizhun: "Lowest Price",
    wuxianzhi: "Unlimited",
    xiangduizuidijia: "Lowest Relative Price",
    quantianzuidijia: "Lowest Day  Price",
    shiduanzuidijia: "Lowest Time Slot Price",
    hangbanzuidijia: "Lowest Available Fare",
    shishihangbanguankong: "Real-time Flight Control",
    tiqianyudingshijian: "Advance booking time",
    kedingcangweijibie: "Allowed Booking Class",
    kedingzuoweijibie: "Allowed Seat Class",
    xieyijipiaoyouxian: "Preferred Agreement Flights",
    xieyijiudianyouxian: "Preferred Hotel Priority",
    xiaofeijineshangxian: "Spending Limit",
    dangdizhusubiaozhunshangxian: "Local Accommodation Standard Limit",
    yudingxuzhi: "Booking Regulations",
    dingpiao: "Book",
    tuipiaochongkai: "Refund Reissue",
    xuanweiqucheng: "Choose to go",
    yes: "Yes",
    no: "No",
    firstcity: "Tier 1 City",
    seccity: "Tier 2 City",
    thrcity: "Tier 3 City",
    within: "Within",
    qxzhsrxmdm: "Please select or input the project code",
    qxzxmdm: "Please select the project code",
    weibeixiaofeijineshangxian: "Maximum Spending Amount",
    dangdizhusubiaozhun: "Local Accommodation Standard",
    youchuang: "Has Window",
    weichuang: "No windos",
    qianmianfeiquxiao: "Free cancellation before，After",
    zhihoubukequxiao: "non-Refundable",
    wuzao: "Room Only",
    nights: "{number}Nights",
  },
  manage: {},
  bill: {
    bankaccount: "Bank Account",
    acronym: "Abbreviation",
    select: "please choose",
    query: "Inquire",
    added: "Add",
    export: "Export",
    companyname: "company name",
    inorout: "Income and expenditure type",
    accountstatus: "Account Status",
    operation: "operation",
    enable: "Enable",
    disable: "Disable",
    update: "modify",
    content: "Please enter content",
    cancel: "cancel",
    save: "save",
    confirm: "confirm",
    accountadded: "Account addition",
    accountupdate: "Account modification",
    enableordisableprompt: "Is this action used to disable or enable, continue?",
    prompt: "prompt",
    receivebill: "Account receivable period",
    bill: "Account period",
    closeaccountprofit: "Closing gross profit",
    comparisonsales: "Sales comparison",
    closeaccountstarttime: "start date of closing ",
    starttime: "start date",
    closeaccountendtime: "Closing deadline",
    endtime: "Deadline",
    clientname: "client's name",
    customerservicerepresentative: "Customer Service Representative",
    salesrepresentative: "Sales Representative",
    number: "Number of items",
    closeaccountprofittotel: "Closing gross profit",
    inadditioninterestprofit: "Gross profit after interest",
    receiveprice: "Receivable amount",
    actualprofit: "Actual gross profit",
    profitrate: "Gross profit margin",
    interest: "interest",
    additioninterestprofit: "gross profit after interest",
    additioninterestprofitrate: "Gross profit margin after interest",
    profitprecent: "Gross profit ratio",
    back: "<<Back",
    Internationalflight: "International Ticket",
    internalflight: "Domestic ticket",
    Internationalhotel: "international Hotel",
    internalhotel: "Domestic hotel",
    internaltrain: "Domestic train",
    selectyearmonth: "Choose year and month",
    tradebill: "Transaction period",
    agreedpaystarttime: "start date of appointment checkout ",
    agreedpayendtime: "ending date of appointment checkout ",
    billdate: "Billing date",
    billdateend: "Deadline",
    agreedpaydate: "Appointment closing date",
    waitoutday: "Unregistered",
    waitaudited: "Unreviewed",
    waitconfirm: "unconfirmed",
    amountshouldbeclosed: "Amount due",
    detail: "detail",
    total: "total",
    createtime: "Create on",
    orderid: "Order number",
    businesstype: "business type",
    servicetype: "Service type",
    paymentincludinginsurancecharge: "Payable (including service fee /insurance fee)",
    passengername: "Passenger name",
    bookingname: "booked by",
    productname: "product name",
    billaggregate: "Summary of accounts",
    billdetail: "Account period details",
    size: "size",
    amountreceivable: "Uncollected amount",
    allstatus: "All states",
    billname: "Account period name",
    expiretime: "Date of Expiry",
    overdueday: "Days Overdue)",
    receivable: "Receivable",
    havebeentaken: "received",
    notreceive: "unreceived",
    profit: "gross profit",
    totalaccountingperiod: "Total amount outside the account period",
    invoicestatus: "Invoice status",
    statusdetail: "Status (details)",
    Updates: "Update",
    receivedetail: "Receivable details",
    createstarttime: "Creation start date",
    createendtime: "Creation deadline",
    receivestarttime: "Collection start date",
    receiveendtime: "Collection deadline",
    paymentstarttime: "Payment start date",
    paymentendtime: "Payment deadline",
    applyarea: "Area type",
    supplyid: "Supply order number",
    supplyname: "Supply name",
    voucherno: "Document number",
    intentname: "Travel purpose",
    projectcode: "Project code",
    invoiceid: "Invoice number",
    template: "template",
    templatemanager: "Template management",
    fullscreen: "full-screen display",
    quanping: "Exit Full Screen",
    orderselect: "Order select",
    receivestatus: "Collection status",
    invoiceapplication: "Invoice application",
    receiveaudit: "Collection review",
    receiveconfirm: "Receipt confirmation",
    losstreatment: "Loss processing",
    receivefinished: "Collection and closing",
    receiveaudited: "Return of payment",
    costcenter: "Cost Center",
    expenseDepartment: "Expense Bearing Department",
    supplyName: "Supply Name",
    bulkEditingSupplyName: "Bulk Editing Supply Name",
    all: "All",
    paymentstatus: "payment status",
    obligation: "to be paid",
    paymentaudit: "Payment review",
    paymentconfirm: "Payment confirmation",
    paymentfinished: "Collection and closing",
    paymentaudited: "Return of payment",
    orderselecttext: "Please enter the order number to be selected (separated by space, line feed or comma)",
    receivefaila: "Please conduct customer inquiry first.",
    receivefailb: "Please tick the details you need to operate.",
    receivefailc: "Please select the correct data",
    receivefaild: "Please first set the supply name",
    invoiceapplyfaila: "Please select data that has not submitted an invoice request",
    order: "Order",
    losstreatmentfail: "If the closing margin is more than 10% or less than 10%, please first deal with the loss.",
    loading: "Executing operation...",
    orderselectfail: "Please enter the order number for which you want to tick the details.",
    tradedetail: "Transaction details",
    templatename: "Template name",
    rightmove: "move to the right",
    leftmove: "move to the left",
    topmove: "Move up",
    bottommove: "Move down",
    rightfaila: "Please select the data to be moved to the right",
    leftfaila: "Please select the data to be moved to the left",
    topfaila: "This data cannot be moved up",
    bottomfaila: "This data cannot be moved down",
    templatfaila: "Please select a piece of data to move up and down",
    costcenternamesearch: "Cost name search",
    expenseDepartmentNameSearch: "Expense bearing department name search",
    supplyNamesearch: "Supply name search",
    billnamesearch: "Account name search",
    receivetablefaila: "Please select a cost center",
    selectExpenseDepartment: "Please select an expense bearing department",
    receivetablefailb: "Please quit and re-edit first",
    receivetablefailc: "Please select the account period",
    receivetablefaild: "Please select a supply name",
    billownername: "No account period is set, review in advance",
    profitandlossreasons: "Cause of profit and loss",
    lossreasons: "Reason for loss",
    profitreasons: "Reason for profit",
    reakeven: "No loss",
    losscausefaila: "Please choose the cause of the loss",
    invoiceitemname: "project name",
    invoiceitemmodel: "Specification model",
    invoiceitemunitname: "unit",
    invoiceitemnum: "Quantity",
    invoiceitemfare: "unit price",
    invoiceitemcost: "cost",
    invoiceitemamount: "Amount",
    invoiceitemrate: "tax rate",
    invoiceitemtax: "tax",
    delete: "Delete",
    invoicetitle: "Invoice title",
    invoicetype: "invoice type",
    clientadress: "customer address",
    clientemail: "Customer mailbox",
    remark: "Remarks",
    invoiceapplyfaila: "Please enter the correct quantity",
    invoiceapplyfailb: "Please enter the correct unit price",
    invoiceapplyfailc: "Please enter the correct tax rate",
    invoiceapplyfaild: "The submitted invoice price cannot be greater than the original invoice price",
    invoiceapplyfaile: "Successful invoice application",
    accountname: "account name",
    accounttype: "account type",
    tradeaccountlistfaila: "Please enter the correct amount",
    tradeaccountlistfailb: "Recharge successfully entered",
    tradeaccountlist: "Account list",
    availablebalance: "Available Balance",
    accountbalance: "Account Balance",
    creditbalance: "credits",
    blockedamount: "Frozen amount",
    flow: "account statement ",
    recharge: "Recharge",
    blockedtransactions: "Transaction freezing",
    tradename: "Name of Trade",
    freezingtime: "Freezing time",
    creditline: "credit line",
    contractdate: "Contract date",
    creditaddedprompt: "The fixed credit line is valid according to the contract date. If it is expired, please renew it.",
    provisionalcredit: "Temporary credit",
    effectivedate: "effective date",
    expirydate: "Expiration date",
    lodamt: "Recharge amount",
    transactionflowing: "Trading log",
    tradedate: "transaction date",
    flowtype: "account statement type",
    transactionamount: "The transaction amount",
  },
  webdata: {
    interfaceManage: "interfaceManage",
    ChangeCheckPNR: "ChangeCheckPNR",
    insuranceamend: "refund processing",
    supplylist: "supplylist",
    orderlist: "Order list",
    mallservice: "Mall service",
    wechat: "webdata",
    dealwarranty: "Policy processing",
    insuranceorder: "Insurance order",
    insuranceservice: "Insurance service",
    insurancepolicy: "Insurance policy",
    changruletime: "Change time limit",
    baggagerule: "Baggage Rule",
    departmanage: "Department management",
    see: "View",
    oftenconsumermanage: "Frequent passenger management",
    oftenconsumer: "Common passengers",
    costcenter: "Cost Center",
    expenseDepartment: "Expense Bearing Department",
    deal: "prccess",
    waitdispos: "To be processed",
    waitdispose: "To be processed",
    waitpayment: "to be paid",
    waitconfirm: "to be confirmed",
    waitthrowin: "to be reviewed",
    waitapprove: "to be approved",
    waitsubmit: "to be submitted",
    waitrefund: "to be refunded",
    waitbooking: "to be reserved ",
    addressmanage: "Address management",
    dealorder: "Order processing",
    ordermanage: "Order management",
    subservice: "Subscription service",
    dealinvoice: "Invoice processing",
    inviceservice: "Invoice service",
    invoicemanage: "Invoice management",
    servicefeesetting: "Service fee setting",
    servicemanage: "Service management",
    serviceinfo: "Service Information",
    interfaceinfo: "Interface Information",
    payment: "payment",
    dealpayment: "Payment processing",
    peoplemanage: "Personal management",
    companysetting: "Company configuration",
    internationflight: "International Ticket",
    internationhotel: "international Hotel",
    internationaltour: "international travel",
    chinatraffic: "Domestic traffic",
    chinatrain: "Domestic train",
    chinaflight: "Domestic ticket",
    chinahotel: "Domestic hotel",
    chinatravel: "Domestic travel",
    trainorder: "Train order",
    flightorder: "Ticket order",
    trafficorder: "Order processing",
    basedata: "Basic data",
    transaction: "Transaction details",
    tradereceive: "Receivable details",
    tradepayment: "Transaction details",
    smstemplate: "SMS template",
    datastatistics: "Data statistics",
    tradeweek: "Transaction period",
    billreceive: "Account receivable period",
    billpayment: "Transaction period",
    hotelorder: "hotel order",
    customermanage: "Customer management",
    customerlevel: "Customer level",
    dealdelivery: "Express processing",
    deliveryservice: "Delivery Service",
    deliverypolicy: "Express policy",
    flowmanage: "Process management",
    tourorder: "Travel order",
    companymanage: "Company management",
    companyinfo: "Company Information",
    companyhome: "Business homepage",
    visaorder: "Visa order",
    visaservice: "Visa service",
    allorder: "All orders",
    purviewmanage: "authority management",
    purviewcontrol: "authority control",
    approve: "Approval",
    dealmoneyin: "Collection processing",
    moneynandoutmanage: "Income and expenditure management",
    authorizemanage: "Authorization management",
    amendorder: "Refunded and changed order",
    changeamendrule: "refunding and changing rules",
    clientuser: "Big customer",
    domainmanage: "Domain management",
    notifymanage: "Notification management",
    dealrefund: "Refund processing",
    dealamend: "Refund processing",
    dealamendorder: "Refund processing",
    dealamendtour: "group refund processing",
    webmanage: "Website management",
    mineinfo: "my information",
    usermain: "my home page",
    systemmanage: "System Management",
    discrete: "Split",
    forbiddened: "disabled",
    canceled: "Cancelled",
    throwined: "Go online",
    rejected: "Returned",
    rejectes: "Returned",
    finished: "completed",
    finishes: "completed",
    hanguped: "Go offline",
    bankaccount: "Bank Account",
    coupon: "coupon",
    employeemanage: "Employee management",
    cannnot: "Temporarily can't",
    cannot: "Temporarily can't",
    accountsafe: "configurat management",
    accountmanage: "Account management",
    tradeaccount: "Trade Account",
    financemanage: "Accounting management",
    policymanage: "Policy management",
    policymangage: "Policy management",
    jobmanage: "Position management",
    businessservice: "Business trip service",
    chargeservice: "Value-added services",
    chargepolicy: "Service Policy",
    feedback: "Feedback",
    mallservice: "Mall service",
    orderchange: "Flight Change",
    smsnotify: "Notification",
    orderlist: "Orders",
    sharelist: "MG active",
  },
  category: {
    AmendingFlight: "Part Amending",
    ChangeingFlight: "Part Changeing",
    AmendingTrain: "Part Amending",
    ChangeingTrain: "Part Changeing",
    AmendingHotel: "Part Amending",
    ChangeingHotel: "Part Changeing",
    AmendingTour: "Part Amending",
    ChangeingTour: "Part Changeing",
    AmendedFlight: "Part Amended",
    ChangeedFlight: "Part Changeed",
    AmendedTrain: "Part Amended",
    ChangeedTrain: "Part Changeed",
    AmendedHotel: "Part Amended",
    ChangeedHotel: "Part Changeed",
    AmendedTour: "Part Amended",
    ChangeedTour: "Part Changeed",
    AllAmendingFlight: "Amending",
    AllChangeingFlight: "Changeing",
    AllBookingFlight: "Booking",
    AllAmendingTrain: "Amending",
    AllChangeingTrain: "Changeing",
    AllBookingTrain: "Booking",
    AllAmendingHotel: "Amending",
    AllChangeingHotel: "Changeing",
    AllBookingHotel: "Booking",
    AllAmendingTour: "Amending",
    AllChangeingTour: "Changeing",
    AllBookingTour: "Booking",
    AllAmendedFlight: "Amended",
    AllChangeedFlight: "Changeed",
    AllBookedFlight: "Booked",
    AllAmendedTrain: "Amended",
    AllChangeedTrain: "Changeed",
    AllBookedTrain: "Booked",
    AllAmendedHotel: "Amended",
    AllChangeedHotel: "Changeed",
    AllBookedHotel: "Booked",
    AllAmendedTour: "Amended",
    AllChangeedTour: "Changeed",
    AllBookedTour: "Booked",

    "1672category": "HotelFare",
    "1674category": "TeamFare",
    "1660category": "TicketFare",
    "1662category": "BuildFare",
    "1664category": "FuelFare",
    "1666category": "TaxFare",
    "1692category": "DirectReduction",
    "1668category": "SafeFare",
    "1670category": "ServiceFare",
    "1678category": "AmendFare",
    "1682category": "ChangeFare",
    "1684category": "OldPrice",
    "1690category": "OtherFare",
    "1694category": "ThrowDiscount",
    Conference: "Conference",
    EnterprisesUnit: "Enterprises and institutions",
    GovernmentDepartment: "Government agencies",
    PeopleEnterprises: "Private assets",
    CountryCapital: "State-owned Assets",
    ChinaOuterJoinCapital: "Sino-foreign joint venture",
    ForeignCompany: "Foreign-owned",
    CompanySize100: "Less than 100 people",
    CompanySize499: "100~499",
    CompanySize999: "500~999",
    CompanySize4999: "1000~4999",
    CompanySize5kUp: "More than 5000",
    Internal: "Domestic",
    Overseas: "International",
    IDCard: "ID card",
    PassportCard: "passport",
    StudentCard: "Student card",
    OfficerCard: "Military officer card",
    OtherCard: "other",

    Residencepermit: "Residence permit for Hong Kong, Macao and Taiwan residents",
    ForeignResidentIDCard: "Foreign Permanent Resident ID Card",
    HKCompatriotsyndrome: "Hong Kong and Macau Exit-Entry Permit",
    TaiCompatriotsyndrome: "Taiwan travel permit",

    Enable: "Enable",
    UnEnable: "Disable",
    Male: "male",
    Female: "Female",
    Yes: "Yes",
    No: "no",
    SingleVoyage: "One Way",
    RoundVoyage: "Round Trip",
    ReturnVoyage: "Return journey",
    MultiVoyage: "Multi journey",
    TransferVoyage: "Transfer journey",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "Overseas electronics",
    ConnectVoyage: "Interconnection",
    Team: "group ",
    Fit: "Individual",
    Unlimited: "Unlimited",
    HighOpen: "open high",
    DownOpen: "open low",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    WithinIntercontinental: "Within the same intercontinental range",
    PolicyDepartAirport: "range of the policy originating airport ",
    NoReward: "No reward",
    AgencyFreeFee: "No agency fee",
    MustBackAirport: "Must return to the airport with same trip",
    AppointBackAirport: "Specify return country or airport range",
    CommonFlight: "Ordinary flight",
    ShareFlight: "Shared flight",
    Prepay: "Prepaid",
    CashPay: "by cash",
    OverseasStudent: "International student",
    Immigrant: "Immigration",
    Worker: "labor",
    Seaman: "sailor",
    Youth: "youth",
    HkMacaoTw: "Hong Kong, Macao and Taiwan",
    ForeignNationality: "Foreign nationality",
    NotChineseName: "Non-Chinese character name",
    AddOn: "Add-On",
    OldGge: "Old people",
    OverseasTransfer: "Transit abroad",
    NotchRange: "Flight schedule with land transport",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q value",
    SharedFlight: "Shared flight",
    ThreeAgreement: "Tripartite agreement ",
    Package: "Package",
    WholeGroup: "Whole group",
    SmallGroup: "Small group",
    RewardsAdults: "Reward is the same as adults",
    NoOpenBonus: "No reward",
    WithoutReward: "Can be opened, no reward",
    NotOpen: "can't be opened",
    NoCodingRequired: "No need to return code",
    CodeOut: "Change code for ticketing",
    BigTicket: "ticketing with big number (no need to change)",
    BigNoTicket: "ticketing with big number (need to change)",
    NoChange: "No seat, no change of ticket (change when there is seat)",
    // SingleVoyage: "One Way",
    // RoundVoyage: "Round Trip",
    SingleRound: "One way / round trip",
    MonthCycle: "month",
    WeekCycle: "week",
    DayCycle: "day",
    HKMpermit: "Exit-Entry Permit for Travelling to and from Hong Kong and Macao ",
    TaiWpermit: "Travel Permit for Mainlanders to Enter and Exit Taiwan",
    OnlineServiceMode: "Online service",
    LineServiceMode: "Offline service",
    PercentageMode: "percentage",
    FixedPrice: "fixed amount",
    ExpensePrice: "Ticket price",
    PriceFareAndTax: "Ticket price + tax",
    DirectUpdate: "Direct modification",
    AddLittle: "add a little",
    ReduceLittle: "reduce a little",
    User: "user",
    Jobs: "job title",
    Group: "Group",
    Department: "department",
    Company: "company",
    Service: "service",
    Customer: "client",
    Actions: "Permission",
    CostCenter: "Cost Center",
    ExpenseDepartment: "Expense Bearing Department",
    Server: "Server-side",
    Client: "Client-side",
    Normal: "normal",
    Change: "change",
    SelfOnly: "Only yourself",
    SelfLower: "yourself and subordinate",
    NoLimit: "not limited",
    UnAuthorized: "unauthorized",
    Authorized: "Authorized",
    SystemRole: "System role",
    UserRole: "User role",
    ContinueBefore: "Before continuing",
    ContinueAfter: "After continuing",
    ReturnBefore: "Before returning",
    ReturnAfter: "After returning",
    ChangeBefore: "Before change",
    ChangeAfter: "After change",
    NeedInvoice: "Need invoice",
    NoInvoice: "Do not need invoice",
    WEB: "website",
    RMB: "yuan",
    Dollar: "Dollar",
    Alipay: "Alipay",
    WeChat: "WeChat",
    Cash: "cash",
    Monthly: "Monthly statement",
    Tour: "Tour",
    Hotel: "Hotel",
    Flight: "Flight",
    AdviceNote: "Group notice",
    GuestEnclosure: "Guest attachment",
    other: "Other",
    Electronic: "Electronic contract",
    ClientMessage: "Leave a message to guest",
    SupplyMessage: "Leva a message to supplier",
    WorkmateMessage: "Leave a message to colleague",
    Traveled: "Traveled",
    NotTravel: "Have not traveled",
    Change: "change",
    Sales: "Sales",
    Refund: "Refund",
    PasswordVerify: "Login password",
    EmailVerify: "E-mail verification",
    PhoneVerify: "Phone verification",
    NameVerify: "Real name verification",
    SafetyProblem: "safety question",
    WEB: "website",
    APP: "Mobile phone",
    BtripService: "Business trip service",
    HotelService: "hotel service",
    TourService: "Travel services",
    FlightService: "Ticket service",
    ChargeService: "Value-added services",
    HightDirector: "Who is my class teacher in high school?",
    Firstgame: "First game accomplished",
    PhoneContact: "Mobile phone",
    TelephoneContact: "phone",
    EmailContact: "Email",
    QQ: "QQ",
    OnlineKnow: "Online booking instructions",
    TourKnow: "Domestic travel booking instructions",
    Enable: "Enable",
    UnEnable: "Disable",
    PriceEnable: "Price enabled",
    PriceUnEnable: "Price disabled",
    Indeterminate: "Price to be determined",
    PrivatePolicy: "Private policy",
    PublicPolicy: "Public policy",
    Receive: "Receive",
    Payment: "pay",
    Unsubmit: "Unsubmitted",
    Submited: "Submitted",
    Unaudit: "Not approved",
    Audited: "Approved",
    AuditRefuse: "Approval rejection",
    Untreated: "Unprocessed",
    RefundeBad: "Fail to withdraw",
    RefundeIng: "Withdrawal processing",
    Refunded: "Successfully wirhdraw",
    Country: "Country",
    Scenic: "Scenic spot",
    City: "city",
    Province: "province",
    Area: "Region",
    Airport: "Airport",
    Continent: "Continent",
    District: "District",
    Invite: "Pick up",
    Mail: "Mailing",
    insideOutside: "Domestic origin",
    outsideInside: "Direct flight SOTO",
    insideInsideOutside: "Domestic originating Add-On",
    outsideInsideInside: "Foreign originating Add-On",
    outsideOutside: "Overseas to overseas",
    insideOutsideOutside: "Domestic originating transit",
    outsideOutsideInside: "Foreign originating transit",
    outsideOutsideOutside: "Overseas overseas overseas",
    outsideInsideOutside: "Overseas domestic overseas",
    globalGlobal: "Global to global",
    globalGlobalGlobal: "Global transit global",
    openAgencyFee: "Can invoice with no agency fee",
    NoWay: "Cannot invoice",
    InsuranceService: "Insurance service",
    ExpressService: "Delivery Service",
    InvoiceService: "Invoice service",
    VisaService: "Visa service",
    TrainService: "Train service",
    TravelNotes: "Booking instructions",
    ExpenseKnowledge: "Fee instrucitons",
    ShortMessage: "SMS",
    Mail: "mail",
    Wechat: "WeChat",
    EexamineOrderSms: "Approve order message content",
    EexamineApprovalSms: "Message content approved",
    EexamineRefuseSms: "Message content rejected ",
    EexamineAccomplishSms: "Order processing, complete message content",
    Refunds: "Refund completed",
    Transfer: "Transfer",
    Train: "Train ticket",
    BusinessSeat: "Business class",
    SpecialSeat: "special class",
    Level1Seat: "First-class seat",
    Level2Seat: "second class seat",
    HighGradeSleeper: "Senior soft sleeper",
    CommonSleeper: "Soft sleeper",
    HardSleeper: "Hard sleeper",
    SoftSeat: "Soft seat",
    HardSeat: "Hard seat",
    NotHaveSeat: "No seat",
    Economy: "Economic class",
    Buissenes: "Business class",
    First: "First class",
    DayLowestPrice: "Lowest price throughout the day",
    FlightLowestPrice: "Lowest price of the whole flight",
    HighSpeedRail: "High-speed rail",
    SleepingBerth: "Sleeper",
    Other: "fast passenger train and other",
    Whole: "All",
    Position: "position",
    Department: "department",
    FlatFeeCharges: "Fixed charge",
    PercentageCostFee: "Charge by percentage",
    Department: "This department",
    DepartmentLower: "This department and subordinates",
    TravelPurpose: "Travel purpose",
    PolicyCause: "Policy reason",
    FlightChange: "I have to change my itinerary and don't want to fly",
    FlightMistaken: "Wrong trip, date, time, name",
    FlightDelay: "Flight delay or cancellation",
    OnBusiness: "Business",
    OnPersonal: "Personal",
    PayApproval: "Order payment approval",
    ChangeApproval: "Order change approval",
    ReturnTicketApproval: "Order refund approval",
    People: "Charge by person",
    legs: "Charge by segment",
    OnLineReservation: "Online booking",
    OffLineReservation: "Offline booking",
    WorkingTime: "working time",
    NonWorkingTime: "Non-working time",
    OnlineBookingApproval: "Online booking needs approval",
    OfflineBookingApproval: "Offline booking needs approval",
    ViolateRuleApproval: "Violation of rules needs approval",
    ChangeTripApproval: "Change of the trip needs approval",
    CancelTripApproval: "Cancellation of the trip needs approval",
    Preflight: "Before takeoff",
    AfterTakeoff: "After takeoff",
    RuleEndorse: "Change",
    RuleFund: "Refund",
    Reserve: "Book",
    CaterService: "Catering Services",
    TrafficService: "Transportation service",
    TicketService: "Ticket service",
    BaseService: "Basic services",
    Volunteer: "Volunteer",
    FlightChang: "Flight change",
    BuyAgain: "Repurchase",
    SickAmend: "Refund due to sickness",
    NameError: "Wrong name",
    CabinChange: "Upgrade",
    TicketInvalid: "invalid ticket",
    Other: "other",
    WaitSubmit: "To be submitted",
    WaitPayment: "To be paid",
    WaitConfirm: "unconfirmed",
    Finished: "confirmed",
    Canceled: "Cancelled",
    Rejected: "Returned",
    SystemService: "system service",
    WorkService: "Work service",
    OrderService: "Order service",
    BillService: "Billing service",
    UserService: "Personal service",
    CompanyService: "Corporate Service",
    TicketFare: "Ticket face",
    BuildFare: "airrax",
    FuelFare: "Fuel",
    TaxFare: "Tax",
    SafeFare: "Insurance",
    ServiceFare: "service",
    HotelFare: "Room rate",
    TeamFare: "Group fee",
    AmendFare: "Refund",
    ChangeFare: "change",
    OtherFare: "other",
    DirectReduction: "Direct reduction",
    ThrowDiscount: "discount",
    Infant: "baby",
    Enfant: "child",
    Young: "adult",
    Wrinkly: "middle aged",
    Elderly: "elderly",
    BusinessLicence: "business license",
    TaxRegistration: "Tax registration certificate",
    Other: "other",
    WaitSubmit: "To be submitted",
    WaitDispose: "To be processed",
    Cannot: "Temporarily cannot",
    Finished: "Completed",
    Rejected: "Rejected",
    Bill: "Approval",
    Balance: "Balance",
    Credit: "Credit",
    Integral: "Integral",
    FixedCredit: "Fixed credit",
    InterimCredit: "Temporary credit",
    WaitOutDay: "To be billed",
    WaitAudited: "To be reviewed",
    WaitConfirm: "To be confirmed",
    WaitReceive: "To be paid",
    Finished: "Closed",
    Rejected: "Returned",
    Change: "Change",
    Bill: "Accounting",
    Company: "Company",
    Product: "product",
    Sales: "Sales",
    Amend: "Refund",
    People: "personal",
    Customer: "Customer service",
    HotelChange: "Change of trip",
    Station: "station",
    CompanyID: "Company",
    People: "personal",
    SpecialTicket: "Special ticket",
    GeneralTicket: "General ticket",
    Electronic: "Electronic invoice",
    Paper: "Paper invoice",
    HotelDelay: "Tripcancelled",
    Economy5: "50% off economic class",
    Economy6: "60% off economic class",
    Economy7: "30% off economic class",
    Economy8: "20% off economic class",
    Economy9: "10% off economic class",
    MessageNotify: "SMS notification",
    MailNotify: "E-mail notification",
    WechatNotify: "WeChat notification",
    AppNotify: "App notification",
    WaitOutDay: "To be billed",
    OverdueNo: "Not overdue",
    OverdueYes: "Overdue",
    Percentage: "percentage",
    FixMoney: "fixed amount",
    RemovePrice: "Excluding price",
    Creater: "creator",
    Member: "Participant",
    Watcher: "Follower",
    Text: "text",
    Html: "HTML",
    Link: "link",
    Plugin: "Plugin",
    CompanyInternal: "inside company",
    CurrentDomainName: "Current domain name",
    AllDomainName: "All domain names",
    Email: "e-mail",
    OrdinaryAddress: "Ordinary address",
    B2C: "B2C",
    B2G: "B2G",
    Demand: "demand",
    WaitBooking: "Reserved",
    WaitApprove: "Approved",
    WaitConfirm: "Confirmed",
    WaitPayment: "To be paid",
    WaitDispose: "Processed",
    Finished: "Completed",
    Canceled: "Cancelled",
    Rejected: "Returned",
    Discrete: "Split",
    Cannot: "Temporarily cannot",
    EmailAuth: "email address",
    MobileAuth: "phone account",
    AccountAuth: "user account",
    WeixinAuth: "WeChat authorization",
    DynamicAuth: "Dynamic verification",
    BookingInfo: "Booking notice",
    PolicyCause: "Violation reason",
    TravelPurpose: "Travel purpose",
    WaitRefund: "To be refunded",
  },
};



// WEBPACK FOOTER //
// ./src/lang/EN.js